"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var DirectionArrowLeft_1 = require("../../Icons/DirectionArrowLeft");
var withBackTitle = function (title, handleBack) {
    return (react_1.default.createElement("div", { className: "anq-header-back" },
        react_1.default.createElement("div", { onClick: handleBack, className: "anq-back-area" },
            react_1.default.createElement(DirectionArrowLeft_1.DirectionArrowLeft, { className: "anq-icon-back" })),
        react_1.default.createElement("div", { className: "anq-seg" }),
        react_1.default.createElement("div", { className: "anq-desc-txt" }, title)));
};
exports.default = withBackTitle;
//# sourceMappingURL=withBackTitle.js.map